export default "__VITE_ASSET__CW3bXDVu__"